<div class="min-h-screen bg-gray-50">
  <app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <!-- Empty Cart -->
    <ng-container *ngIf="cartProducts.length === 0">
      <div class="text-center py-20">
        <div class="w-32 h-32 bg-orange-100 rounded-full mx-auto flex items-center justify-center mb-6">
          <lucide-icon name="shopping-bag" class="w-16 h-16 text-orange-500"></lucide-icon>
        </div>
        <h2 class="text-2xl font-bold text-gray-900 mb-2">Your cart is empty</h2>
        <p class="text-gray-500 mb-6">Add some delicious items from our restaurants</p>
        <button (click)="goHome()" class="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-8 py-3">
          Browse Restaurants
        </button>
      </div>
    </ng-container>

    <!-- Cart with Items -->
    <ng-container *ngIf="cartProducts.length > 0">
      <button (click)="goBack()" class="flex items-center text-gray-600 hover:text-orange-500 mb-6 transition-colors">
        <lucide-icon name="arrow-left" class="w-5 h-5 mr-2"></lucide-icon>
        Continue Shopping
      </button>

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <!-- Cart Items -->
        <div class="lg:col-span-2 space-y-6">
          <h1 class="text-2xl font-bold text-gray-900">Your Cart</h1>

          <!-- <div *ngFor="let group of groupedCart | keyvalue" class="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div class="bg-orange-50 px-6 py-3 border-b border-orange-100">
              <h3 class="font-semibold text-gray-900">{{ group.key }}</h3>
            </div>
            <div class="divide-y divide-gray-100"> -->
          <!-- <div *ngFor="let item of group.value" class="p-4 flex items-center">
                <img [src]="item.image" [alt]="item.name"   loading="lazy" class="w-20 h-20 object-cover rounded-lg" />
                <div class="ml-4 flex-1">
                  <div class="flex items-center space-x-2">
                    <div *ngIf="item.veg" class="w-4 h-4 border-2 border-green-600 flex items-center justify-center">
                      <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                    </div>
                    <div *ngIf="!item.veg" class="w-4 h-4 border-2 border-red-600 flex items-center justify-center">
                      <div class="w-2 h-2 bg-red-600 rounded-full"></div>
                    </div>
                    <h4 class="font-medium text-gray-900">{{ item.name }}</h4>
                  </div>
                  <p class="text-sm text-gray-500 mt-1">₹{{ item.price }} each</p>
                </div>
                <div class="flex flex-col-reverse sm:flex-row items-center space-x-3">
                  <div class="flex items-center space-x-2 bg-gray-50 rounded-lg p-1">
                    <button (click)="updateQuantity(item.id, item.quantity - 1)"
                      class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                      <lucide-icon name="minus" class="w-4 h-4 text-gray-600"></lucide-icon>
                    </button>
                    <span class="w-8 text-center font-medium">{{ item.quantity }}</span>
                    <button (click)="updateQuantity(item.id, item.quantity + 1)"
                      class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                      <lucide-icon name="plus" class="w-4 h-4 text-gray-600"></lucide-icon>
                    </button>
                  </div>
                  <div class="flex justify-center items-center">
                    <span class="sm:inline font-semibold text-gray-900 w-16">
                      ₹{{ item.price * item.quantity }}
                    </span>
                    <button (click)="removeItem(item.id)"
                      class="sm:inline-flex p-2 text-gray-400 hover:text-red-500 transition-colors">
                      <lucide-icon name="trash-2" class="w-5 h-5"></lucide-icon>
                    </button>
                  </div>
                </div>
              </div> -->

          <div *ngFor="let group of groupedCart | keyvalue" class="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div class="bg-orange-50 px-6 py-3 border-b border-orange-100">
              <h3 class="font-semibold text-gray-900">{{ group.key }}</h3>
            </div>
            <div class="divide-y divide-gray-100">
              <div *ngFor="let item of group.value" class="p-4">
                <div class="flex items-start sm:items-center">
                  <img [src]="'../../../../assets/img/' + item.product_Picture" [alt]="item.product_Name" loading="lazy"
                    class="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg flex-shrink-0"
                    onerror="this.src='../../../../assets/img/defaultCake.webp';" />

                  <div class="ml-3 sm:ml-4 flex-1 min-w-0">
                    <!-- Product name and veg/non-veg indicator -->
                    <div class="flex items-center space-x-2 mb-1">
                      <div *ngIf="item.food_Type == 'Veg'"
                        class="w-4 h-4 border-2 border-green-600 flex items-center justify-center flex-shrink-0">
                        <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                      </div>
                      <div *ngIf="item.food_Type == 'Non-Veg'"
                        class="w-4 h-4 border-2 border-red-600 flex items-center justify-center flex-shrink-0">
                        <div class="w-2 h-2 bg-red-600 rounded-full"></div>
                      </div>
                      <h4 class="font-medium text-gray-900 text-sm sm:text-base truncate">{{ item.product_Name }}</h4>
                    </div>

                    <!-- Price per item -->
                    <p class="text-xs sm:text-sm text-gray-500">₹{{ item.net_Sale_Price | number: "1.2-2" }} each</p>

                    <!-- Mobile: All actions in one aligned row -->
                    <div class="flex items-center justify-between mt-3 sm:hidden">
                      <!-- Quantity controls -->
                      <div class="flex items-center space-x-1 bg-gray-50 rounded-lg p-1">
                        <button (click)="decreaseQuantity(item)"
                          class="w-7 h-7 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                          <lucide-icon name="minus" class="w-3 h-3 text-gray-600"></lucide-icon>
                        </button>
                        <span class="w-6 text-center font-medium text-sm">{{ item.orderQuantity }}</span>
                        <button (click)="increaseQuantity(item)"
                          class="w-7 h-7 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                          <lucide-icon name="plus" class="w-3 h-3 text-gray-600"></lucide-icon>
                        </button>
                      </div>

                      <!-- Price and delete button -->
                      <div class="flex items-center space-x-3">
                        <span class="font-semibold text-gray-900 text-sm whitespace-nowrap">
                          ₹{{ item.orderQuantity * item.net_Sale_Price | number: "1.2-2" }}
                        </span>
                        <button (click)="removeCartProduct(item)"
                          class="p-1.5 text-gray-400 hover:text-red-500 transition-colors">
                          <lucide-icon name="trash-2" class="w-4 h-4"></lucide-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Desktop: Price, quantity and delete -->
                  <div class="hidden sm:flex items-center space-x-3 ml-4">
                    <div class="flex items-center space-x-2 bg-gray-50 rounded-lg p-1">
                      <button (click)="decreaseQuantity(item)"
                        class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                        <lucide-icon name="minus" class="w-4 h-4 text-gray-600"></lucide-icon>
                      </button>
                      <span class="w-8 text-center font-medium">{{ item.orderQuantity }}</span>
                      <button (click)="increaseQuantity(item)"
                        class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                        <lucide-icon name="plus" class="w-4 h-4 text-gray-600"></lucide-icon>
                      </button>
                    </div>

                    <span class="font-semibold text-gray-900 w-20 text-right">₹{{ item.orderQuantity *
                      item.net_Sale_Price | number: "1.2-2"
                      }}</span>

                    <button (click)="removeCartProduct(item)"
                      class="p-2 text-gray-400 hover:text-red-500 transition-colors">
                      <lucide-icon name="trash-2" class="w-5 h-5"></lucide-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->



            <!-- </div> -->

            <!-- 
            <div class="divide-y divide-gray-100">
              <div *ngFor="let item of group.value" class="p-3 sm:p-4">
                <div class="flex items-start">
                  <img [src]="item.image" [alt]="item.name"
                    class="w-14 h-14 sm:w-20 sm:h-20 object-cover rounded-lg flex-shrink-0" />

                  <div class="ml-3 sm:ml-4 flex-1 min-w-0">
                    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                      <div class="mb-2 sm:mb-0">
                        <div class="flex items-center space-x-2">
                          <div *ngIf="item.veg"
                            class="w-4 h-4 border-2 border-green-600 flex items-center justify-center flex-shrink-0">
                            <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                          </div>
                          <div *ngIf="!item.veg"
                            class="w-4 h-4 border-2 border-red-600 flex items-center justify-center flex-shrink-0">
                            <div class="w-2 h-2 bg-red-600 rounded-full"></div>
                          </div>
                          <h4 class="font-medium text-gray-900 text-sm sm:text-base truncate">{{ item.name }}</h4>
                        </div>
                        <p class="text-xs sm:text-sm text-gray-500 mt-1">₹{{ item.price }} each</p>
                      </div>

                      <div class="flex items-center space-x-2 sm:space-x-3">
                        <div class="flex items-center space-x-1 bg-gray-50 rounded-lg p-1">
                          <button (click)="updateQuantity(item.id, item.quantity - 1)"
                            class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                            <lucide-icon name="minus" class="w-3 h-3 sm:w-4 sm:h-4 text-gray-600"></lucide-icon>
                          </button>
                          <span class="w-6 sm:w-8 text-center font-medium text-sm sm:text-base">{{ item.quantity
                            }}</span>
                          <button (click)="updateQuantity(item.id, item.quantity + 1)"
                            class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50">
                            <lucide-icon name="plus" class="w-3 h-3 sm:w-4 sm:h-4 text-gray-600"></lucide-icon>
                          </button>
                        </div>

                        <span class="font-semibold text-gray-900 text-sm sm:text-base whitespace-nowrap">
                          ₹{{ item.price * item.quantity }}
                        </span>

                        <button (click)="removeItem(item.id)"
                          class="p-1.5 sm:p-2 text-gray-400 hover:text-red-500 transition-colors">
                          <lucide-icon name="trash-2" class="w-4 h-4 sm:w-5 sm:h-5"></lucide-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

          </div>
        </div>

        <!-- Order Summary -->
        <div class="lg:col-span-1">
          <div class="bg-white rounded-2xl shadow-sm p-6 sticky top-24">
            <h2 class="text-lg font-bold text-gray-900 mb-4">Order Summary</h2>

            <!-- Coupon Input -->
            <div class="flex space-x-2 mb-6">
              <input type="text" [(ngModel)]="couponCode" placeholder="Enter coupon code"
                class="w-[70%] rounded-lg py-2 px-2 border border-gray-200 focus:outline-none focus:border-orange-500" />
              <button class="w-[30%] rounded-lg px-4 py-2 border border-gray-300 font-medium hover:bg-gray-50">
                Apply
              </button>
            </div>

            <!-- Applied Offer -->
            <div class="bg-teal-50 border border-teal-200 rounded-lg p-3 mb-6">
              <div class="flex items-center">
                <lucide-icon name="tag" class="w-5 h-5 text-teal-600 mr-2"></lucide-icon>
                <div>
                  <!-- <p class="text-sm font-medium text-teal-800">CAPITAL30 Applied!</p> -->
                  <p class="text-xs text-teal-600">You're saving ₹{{ totDiscount | number: "1.2-2" }}</p>
                </div>
              </div>
            </div>

            <!-- Price Breakdown -->
            <div class="space-y-3 text-sm">
              <div class="flex justify-between">
                <span class="text-gray-600">Subtotal</span>
                <span class="text-gray-900">₹{{ totalSaleAmt | number: "1.2-2" }}</span>
              </div>
              <div class="flex justify-between" *ngIf="totBasePremiumFlavourPrice > 0">
                <span class="text-gray-600">Flavour Premium Price</span>
                <span class="text-gray-900">{{ totBasePremiumFlavourPrice | number: "1.2-2" }}</span>
              </div>
              <div class="flex justify-between text-teal-600" *ngIf="totDiscount > 0">
                <span>Discount</span>
                <span>-₹{{ totDiscount | number: "1.2-2" }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Taxble Value</span>
                <span class="text-gray-900">{{ totTaxValue | number: "1.2-2" }}</span>
              </div>

              <div class="flex justify-between" *ngIf="gstAmt > 0">
                <span class="text-gray-600">GST</span>
                <span class="text-gray-900">{{ gstAmt | number: "1.2-2" }}</span>
              </div>

              <div class="flex justify-between" *ngIf="cessAmt > 0">
                <span class="text-gray-600">CESS</span>
                <span class="text-gray-900">{{ cessAmt | number: "1.2-2" }}</span>
              </div>

              <div class="flex justify-between" *ngIf="netAmountBeforeRoundedOff >= minimumOrdeSetup?.orderMinValue">
                <span class="text-gray-600">Net Amount</span>
                <span class="text-gray-900">{{ netAmountBeforeRoundedOff | number: "1.2-2" }}</span>
              </div>

              <div class="flex justify-between" *ngIf="netAmountBeforeRoundedOff < minimumOrdeSetup?.orderMinValue">
                <span class="text-gray-600">Net Amount</span>
                <span class="text-gray-900">{{ netAmountBeforeRoundedOff | number: "1.2-2" }}</span>
              </div>

              <div class="flex justify-between">
                <span class="text-gray-600">Rounded off Amount</span>
                <span class="text-gray-900">{{ roundedOffAmount | number: "1.2-2" }}</span>
              </div>
              <!-- <div class="flex justify-between">
                <span class="text-gray-600 flex items-center">
                  <lucide-icon name="truck" class="w-4 h-4 mr-1"></lucide-icon> Delivery Fee
                </span>
                <span class="text-teal-600 font-medium">FREE</span>
              </div> -->
              <div class="flex justify-between">
                <span class="text-gray-600">Packaging Fee</span>
                <span class="text-teal-600 font-medium">FREE</span>
              </div>
              <hr class="border-gray-200" />
              <div class="flex justify-between text-lg font-bold">
                <span class="text-gray-900">Total</span>
                <span class="text-gray-900">₹{{ grandTotal | number: "1.2-2" }}</span>
              </div>
            </div>

            <!-- Checkout Button -->
            <!-- <button (click)="checkout()"
              class="w-full mt-6 bg-orange-500 hover:bg-orange-600 text-white rounded-full py-4 text-lg font-semibold">
              Proceed to Checkout
            </button> -->

            <span *ngIf="isShowCheckOut">
              <!-- <span *ngIf="grandTotal >= minimumOrdeSetup?.orderMinValue">
                <a class="btn btn-success btn-check-out" (click)="getProductWithStock()">Check Out</a>
              </span> -->
              <button *ngIf="grandTotal >= minimumOrdeSetup?.orderMinValue" (click)="checkout()"
                class="w-full mt-6 bg-orange-500 hover:bg-orange-600 text-white rounded-full py-4 text-lg font-semibold">
                Proceed to Checkout
              </button>

              <!-- <span *ngIf="grandTotal < minimumOrdeSetup?.orderMinValue">
                <a class="btn btn-danger btn-check-out1" id="min_pay_btn">
                  <span class="min_pay">
                    Add <strong>₹ {{ minimumOrdeSetup?.orderMinValue - grandTotal | number: '1.2-2'
                      }}</strong> more to checkout</span>
                </a>
              </span> -->
              <button class="w-full mt-6 bg-red-500 hover:bg-red-600 text-white rounded-full py-4 text-lg font-semibold"
                *ngIf="grandTotal < minimumOrdeSetup?.orderMinValue">
                <!-- <a class="btn btn-danger btn-check-out1" id="min_pay_btn"> -->
                <!-- <span class="min_pay"> -->
                Add <strong>₹ {{ minimumOrdeSetup?.orderMinValue - grandTotal | number: '1.2-2'
                  }}</strong> more to checkout
                <!-- </span> -->
                <!-- </a> -->
              </button>
            </span>
            <!-- <span *ngIf="!isShowCheckOut">
              <a class="btn btn-success btn-check-out" style="cursor: progress">Please wait...</a>
            </span> -->
            <button *ngIf="!isShowCheckOut"
              class="w-full mt-6 bg-green-500 hover:bg-green-600 text-white rounded-full py-4 text-lg font-semibold">
              Please wait...
            </button>

            <p class="text-xs text-gray-500 text-center mt-4">
              By placing this order, you agree to our Terms & Conditions
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <app-footer></app-footer>
</div>